import { CityItem } from "@shared/lib/utils/getCityCenterPoint/types";

export const filteredCities: CityItem[] = require("./config/filteredCities.json");